const Menu = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#000000"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        stroke="currentColor"
        d="M20.5002 6.50003H3.50002C3.10219 6.50003 2.72065 6.342 2.43934 6.06069C2.15804 5.77938 2 5.39785 2 5.00002C2 4.60219 2.15804 4.22065 2.43934 3.93934C2.72065 3.65804 3.10219 3.5 3.50002 3.5H20.5002C20.898 3.5 21.2796 3.65804 21.5609 3.93934C21.8422 4.22065 22.0002 4.60219 22.0002 5.00002C22.0002 5.39785 21.8422 5.77938 21.5609 6.06069C21.2796 6.342 20.898 6.50003 20.5002 6.50003ZM20.5002 13.5001H3.50002C3.10219 13.5001 2.72065 13.3421 2.43934 13.0608C2.15804 12.7795 2 12.3979 2 12.0001C2 11.6023 2.15804 11.2207 2.43934 10.9394C2.72065 10.6581 3.10219 10.5001 3.50002 10.5001H20.5002C20.898 10.5001 21.2796 10.6581 21.5609 10.9394C21.8422 11.2207 22.0002 11.6023 22.0002 12.0001C22.0002 12.3979 21.8422 12.7795 21.5609 13.0608C21.2796 13.3421 20.898 13.5001 20.5002 13.5001ZM3.50002 20.5002H20.5002C20.898 20.5002 21.2796 20.3422 21.5609 20.0608C21.8422 19.7795 22.0002 19.398 22.0002 19.0002C22.0002 18.6023 21.8422 18.2208 21.5609 17.9395C21.2796 17.6582 20.898 17.5002 20.5002 17.5002H3.50002C3.10219 17.5002 2.72065 17.6582 2.43934 17.9395C2.15804 18.2208 2 18.6023 2 19.0002C2 19.398 2.15804 19.7795 2.43934 20.0608C2.72065 20.3422 3.10219 20.5002 3.50002 20.5002Z"
      />
    </svg>
  );
};

export default Menu;
